export const TOOLS_PERMS = [
  "amz_dashboard", "sales_tracker", "price_tracker", "fba", "planner", "reviews",
  "listing_quality", "recommendations", "settlement_analysis", "reconciliation", "pnl", "ad_invoices", "stock_alerts", "shipments", "returns_analysis", "inventory_removal", "listing_issues", "reimb_recovery",
];

export const canAccess = (user, perm) => {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (perm === "__admin__") return false;
  const perms = user.permissions || [];
  return Array.isArray(perm) ? perm.some((p) => perms.includes(p)) : perms.includes(perm);
};

export const ROUTE_PERMS = [
  ["/", "overview"], ["/channels", "channels"], ["/prices", "prices"],
  ["/tools", TOOLS_PERMS], ["/products", "products"], ["/settlements", "settlements"],
  ["/fees", "mis"], ["/assistant", "assistant"], ["/mcp", "mcp"],
  ["/integrations", "integrations"], ["/keys", "api_keys"],
];

export const firstAllowedPath = (user) => {
  const hit = ROUTE_PERMS.find(([, p]) => canAccess(user, p));
  return hit ? hit[0] : null;
};
